import {
  Button,
  Callout,
  H3,
  Intent,
  NonIdealState,
  Section,
} from '@blueprintjs/core';
import {
  ErrorFallbackContainer,
  ErrorFallbackDescriptionContainer,
} from './styles';

interface ErrorFallbackProps {
  error: Error;
  info: React.ErrorInfo;
  clearError: () => void;
}
const ErrorFallback = ({ error }: ErrorFallbackProps) => {
  return (
    <ErrorFallbackContainer>
      <NonIdealState
        icon="error"
        title={<H3>Ops, algo deu errado</H3>}
        iconMuted={false}
        description={
          <ErrorFallbackDescriptionContainer>
            <span>Por favor tente novamente.</span>
            <span>
              <strong>Erro: </strong> {error.message}
            </span>
            {!!error.stack && (
              <Section
                title="Detalhes"
                collapsible
                collapseProps={{ defaultIsOpen: false }}
              >
                <Callout>
                  <code>{error.stack}</code>
                </Callout>
              </Section>
            )}
          </ErrorFallbackDescriptionContainer>
        }
        action={
          <Button
            onClick={() => window.location.reload()}
            intent={Intent.DANGER}
          >
            Recarregar a página
          </Button>
        }
      />
    </ErrorFallbackContainer>
  );
};

export default ErrorFallback;
